import type { PauseOverlayProps } from './types';
import './styles.css';

/**
 * Pure UI: dim overlay + PAUSED prompt or 3-2-1 countdown.
 * State machine lives in the app shell.
 */
export function PauseOverlayInterface({ phase, countdown }: PauseOverlayProps) {
  if (phase === 'none') {
    return null;
  }

  return (
    <div
      className={
        phase === 'settings'
          ? 'arcade-pause-overlay arcade-pause-overlay--settings'
          : 'arcade-pause-overlay'
      }
      aria-live="polite"
    >
      {phase === 'countdown' && countdown !== null ? (
        <p className="arcade-pause-overlay__count" key={countdown}>
          {countdown}
        </p>
      ) : null}
      {phase === 'prompt' ? (
        <>
          <p className="arcade-pause-overlay__title">PAUSED</p>
          <p className="arcade-pause-overlay__hint">Press Space to continue</p>
        </>
      ) : null}
    </div>
  );
}
